import { useEffect } from 'react';
import { useProducts } from '../context/ProductsContext';
import { useMedia } from '../context/MediaContext';
import { useStock } from '../context/StockContext';

/**
 * Invisible component that signals when the page is fully loaded and ready
 * for prerendering. Sets data-prerender-ready="true" on <html> once all
 * context providers have finished fetching data.
 */
const PrerenderSignal: React.FC = () => {
  const { loading: productsLoading } = useProducts();
  const { loading: mediaLoading } = useMedia();
  const { loading: stockLoading } = useStock();

  useEffect(() => {
    if (!productsLoading && !mediaLoading && !stockLoading) {
      // Small delay to let react-helmet-async flush <head> tags
      const timer = setTimeout(() => {
        document.documentElement.setAttribute('data-prerender-ready', 'true');
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [productsLoading, mediaLoading, stockLoading]);

  return null;
};

export default PrerenderSignal;
